import CreateTariffFormSettings from './CreateTariffFormSettings';

export default CreateTariffFormSettings;
